"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsubscribePage = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactToggle = _interopRequireDefault(require("react-toggle"));

var _StyledToggle = require("./StyledToggle");

var _reactHooks = require("@trycourier/react-hooks");

var _BusinessFooter = require("./BusinessFooter");

var _FreeFooter = require("./FreeFooter");

var PageContainer = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__PageContainer",
  componentId: "sc-1v1c0dj-0"
})(["width:100vw;height:100vh;"]);

var Header = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__Header",
  componentId: "sc-1v1c0dj-1"
})(["background:#ffffff;border-bottom:1px solid #dee8f0;padding:24px 0;width:100%;display:flex;align-items:center;justify-content:center;> div{display:flex;align-items:center;justify-content:space-between;width:100%;max-width:544px;}"]);

var HeaderText = _styledComponents["default"].h1.withConfig({
  displayName: "UnsubscribePage__HeaderText",
  componentId: "sc-1v1c0dj-2"
})(["font-style:normal;font-weight:700;font-size:20px;line-height:28px;color:#1c273a;margin:0;"]);

var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__ImageWrapper",
  componentId: "sc-1v1c0dj-3"
})(["svg,img{height:24px;}"]);

var Body = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__Body",
  componentId: "sc-1v1c0dj-4"
})(["background-color:#f3f6f9;height:100%;width:100%;display:flex;justify-content:center;h4{padding-top:12px;}> div{width:100%;max-width:544px;p:first-child{margin:0;padding:24px 0;}}"]);

var TopicWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__TopicWrapper",
  componentId: "sc-1v1c0dj-5"
})(["display:flex;align-items:center;justify-content:space-between;h1{margin:0;font-style:normal;font-weight:700;font-size:16px;line-height:24px;color:#1c273a;}p{font-style:normal;font-weight:400;font-size:14px;line-height:18px;padding:4px 0;margin:0;color:#1c273a;}"]);

var Divider = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__Divider",
  componentId: "sc-1v1c0dj-6"
})(["left:448px;top:152px;padding:12px 0;background:#f2f6f9;border-bottom:1px solid rgba(86,96,116,0.3);"]);

var SubText = _styledComponents["default"].p.withConfig({
  displayName: "UnsubscribePage__SubText",
  componentId: "sc-1v1c0dj-7"
})(["font-style:normal;font-weight:400;font-size:14px;line-height:18px;padding:24px 0 0 0;margin:0;a{text-decoration:underline;color:#1c273a;}"]);

var FooterContainer = _styledComponents["default"].div.withConfig({
  displayName: "UnsubscribePage__FooterContainer",
  componentId: "sc-1v1c0dj-8"
})(["width:100%;position:fixed;bottom:0;left:0;> div{height:80px;padding:10px;}"]);

var getText = function getText(required, list) {
  if (list) {
    if (required) {
      return "You may still receive this notification as it has been marked required for your account. If you wish to unsubscribe, please contact your account administrator.";
    }

    return "You may still receive this notification. If you do not wish to receive this notification, you may unsubscribe below";
  }

  if (required) {
    return "Your account is required to receive this communication. If you'd like to opt out of this notification, please contact your account administrator.";
  }

  return "You\u2019ve been unsubscribed, we\u2019re sorry to see you go. If you change your mind, you can opt back in below.";
};

var UnsubscribePage = function UnsubscribePage(_ref) {
  var _preferences$preferen, _preferences$preferen2, _preferences$preferen3, _preferences$preferen4, _preferences$preferen5, _preferences$preferen6, _preferences$preferen7;

  var topicId = _ref.topicId,
      preferencePageUrl = _ref.preferencePageUrl,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? false : _ref$list;

  var _useState = (0, _react.useState)(list ? true : false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];

  var preferences = (0, _reactHooks.usePreferences)();
  (0, _react.useEffect)(function () {
    preferences.fetchPreferencePage();
  }, []);
  var topic = (_preferences$preferen = preferences.preferencePage) === null || _preferences$preferen === void 0 ? void 0 : _preferences$preferen.sections.nodes.map(function (section) {
    return section.topics.nodes.filter(function (topic) {
      return topic.templateId === topicId;
    })[0];
  }).filter(Boolean)[0];

  var handleStatusChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var newStatus;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newStatus = !toggle ? "OPTED_IN" : "OPTED_OUT";
              preferences.updateRecipientPreferences({
                templateId: topicId,
                status: newStatus
              });
              setToggle(!toggle);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleStatusChange() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (preferences.isLoading || typeof preferences.isLoading === "undefined") {
    return null;
  }

  if (!preferences.preferencePage && !preferences.isLoading || !topic) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "You have been unsubscribed.");
  }

  return /*#__PURE__*/_react["default"].createElement(PageContainer, null, /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ImageWrapper, null, (_preferences$preferen2 = preferences.preferencePage) !== null && _preferences$preferen2 !== void 0 && _preferences$preferen2.brand.logo.image ? /*#__PURE__*/_react["default"].createElement("img", {
    src: "".concat((_preferences$preferen3 = preferences.preferencePage) === null || _preferences$preferen3 === void 0 ? void 0 : _preferences$preferen3.brand.logo.image)
  }) : /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "48",
    viewBox: "0 0 373 85",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.4 38.3C79.6 38 79.7 37.7 79.6 37.4C76.3 18.7 60 4.5 40.4 4.5C18.3 4.5 0.399987 22.5 0.599987 44.6C0.799987 66.1 18.8 84.1 40.3 84.1C58.5 84.1 73.9 72 78.7 55.3C78.9 54.7 78.6 54.1 78 53.9L76.4 53.3C70 51 62.9 51.9 57.3 55.5C54.7 57.2 52.8 58.6 52.8 58.6C49.6 60.8 45.6 62.1 41.4 62.1C30.2 62.1 22.3 52.9 21.1 41.8L20.2 35.7C19.9 33.8 18.7 32.3 16.9 31.6L14.6 30.7C14.2 30.5 14.1 30.1 14.3 29.7C23.9 16.9 35.7 19.6 35.7 19.6C37.8 19.8 39.6 20.6 41 21.5C43.1 22.9 44.7 25 45.7 27.3C49.3 35.6 57.6 41.4 67.2 41.4C67.2 41.4 76.4 41.8 79.4 38.3Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.1 28.7C26.3702 28.7 27.4 27.6703 27.4 26.4C27.4 25.1298 26.3702 24.1 25.1 24.1C23.8297 24.1 22.8 25.1298 22.8 26.4C22.8 27.6703 23.8297 28.7 25.1 28.7Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.6 40.8C26.2 44.4 29 55.9 41.8 58C42 58 42.1 57.8 41.9 57.7C39 56.3 31.2 51.9 26 40.7C25.8 40.6 25.6 40.6 25.6 40.8Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M141.2 54.9C141.2 71.1 128.9 83.2 112.8 83.2C96.7 83.2 84.5 71.1 84.5 54.9C84.5 38.5 96.7 26.3 112.8 26.3C128.9 26.3 141.2 38.5 141.2 54.9ZM102 54.9C102 61.3 106.7 66.1001 112.9 66.1001C119.2 66.1001 123.9 61.3 123.9 54.9C123.9 48.2 119.2 43.4 112.9 43.4C106.6 43.4 102 48.3 102 54.9Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M199.8 56.7C199.8 72.2 188.9 83.2 173.6 83.2C158.2 83.2 147.2 72.2 147.2 56.7V27.4H165V56.7C165 62.5 168.3 66.1 173.7 66.1C178.8 66.1 182.2 62.4 182.2 56.7V27.4H199.8V56.7Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M243.6 27V43.2C241.6 42.9 239.7 42.5 237.9 42.5C230.5 42.5 224.5 46.4 224.5 56.8V82.1H206.8V27.4H224.5V33.2C227.7 28.9 232.4 26.4 238.4 26.4C240 26.4 241.7 26.6 243.6 27Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M269.9 10.8C269.9 16.6 265.1 21.4 259.4 21.4C253.6 21.4 248.8 16.5 248.8 10.8C248.8 5.10003 253.7 0.300027 259.4 0.300027C265.1 0.200027 269.9 5.10003 269.9 10.8ZM268.1 27.4V82.1H250.4V27.4H268.1Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M329.4 59.4H290.4C291.7 65.1 296.4 68.6 302.5 68.6C307.8 68.6 310.8 66.4 311.6 63.4H329C327.3 75.5 317 83.3 303 83.3C286.8 83.3 274.2 70.8 274.2 54.7C274.2 38.7 286.6 26.4 302.7 26.4C317.6 26.4 329.9 38.2 329.9 53.1C329.8 54.5 329.6 57.4 329.4 59.4ZM311.2 48.2C310.8 43.8 306.5 40.8 301.8 40.8C296.9 40.8 293 43 291.2 48.2H311.2Z",
    fill: "#2C1437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M372.7 27V43.2C370.7 42.9 368.8 42.5 367 42.5C359.6 42.5 353.6 46.4 353.6 56.8V82.1H335.9V27.4H353.6V33.2C356.8 28.9 361.5 26.4 367.5 26.4C369.1 26.4 370.8 26.6 372.7 27Z",
    fill: "#2C1437"
  }))), /*#__PURE__*/_react["default"].createElement(HeaderText, null, "Notification Center"))), /*#__PURE__*/_react["default"].createElement(Body, null, /*#__PURE__*/_react["default"].createElement("div", null, list && /*#__PURE__*/_react["default"].createElement("h4", null, "You've been unsubscribed from this list."), /*#__PURE__*/_react["default"].createElement("p", null, getText((topic === null || topic === void 0 ? void 0 : topic.defaultStatus) === "REQUIRED", list)), /*#__PURE__*/_react["default"].createElement(TopicWrapper, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, topic === null || topic === void 0 ? void 0 : topic.templateName), /*#__PURE__*/_react["default"].createElement("p", null, "Be notified if you are invited to a group or event.")), /*#__PURE__*/_react["default"].createElement(_StyledToggle.StyledToggle, {
    checked: true,
    theme: {
      brand: {
        colors: {
          primary: (_preferences$preferen4 = preferences.preferencePage) === null || _preferences$preferen4 === void 0 ? void 0 : _preferences$preferen4.brand.settings.colors.primary
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactToggle["default"], {
    icons: false,
    disabled: (topic === null || topic === void 0 ? void 0 : topic.defaultStatus) === "REQUIRED",
    checked: toggle,
    onChange: handleStatusChange
  }))), /*#__PURE__*/_react["default"].createElement(Divider, null), /*#__PURE__*/_react["default"].createElement(SubText, null, "You can customize other notifications you receive in the", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: preferencePageUrl
  }, "Notification Center")))), /*#__PURE__*/_react["default"].createElement(FooterContainer, null, (_preferences$preferen5 = preferences.preferencePage) !== null && _preferences$preferen5 !== void 0 && _preferences$preferen5.showCourierFooter ? /*#__PURE__*/_react["default"].createElement(_FreeFooter.FreeFooter, null) : /*#__PURE__*/_react["default"].createElement(_BusinessFooter.BusinessFooter, {
    links: (_preferences$preferen6 = preferences.preferencePage) === null || _preferences$preferen6 === void 0 ? void 0 : _preferences$preferen6.brand.links,
    theme: (_preferences$preferen7 = preferences.preferencePage) === null || _preferences$preferen7 === void 0 ? void 0 : _preferences$preferen7.brand.settings.colors.primary
  })));
};

exports.UnsubscribePage = UnsubscribePage;